import api from "@/services/api";
import {
  FinanceDashboardSummary,
  FinanceEntryType,
  FinanceSummaryType,
} from "@/types/finance/Finance";

class FinanceApi {
  getSummary = async () => {
    const res = await api().get("/finance/summary");
    return res.data as FinanceDashboardSummary;
  };

  listPayables = async (params?: Record<string, unknown>) => {
    const res = await api().get("/finance/payables", { params });
    return res.data as { data: FinanceEntryType[]; total: number };
  };

  getPayable = async (id: string) => {
    const res = await api().get(`/finance/payables/${id}`);
    return res.data as FinanceEntryType;
  };

  createPayable = async (data: Record<string, unknown>) => {
    const res = await api().post("/finance/payables", data);
    return res.data as FinanceEntryType;
  };

  updatePayable = async (id: string, data: Record<string, unknown>) => {
    const res = await api().put(`/finance/payables/${id}`, data);
    return res.data as FinanceEntryType;
  };

  markPayablePaid = async (id: string, paidAt?: string) => {
    const res = await api().post(`/finance/payables/${id}/pay`, { paidAt });
    return res.data as FinanceEntryType;
  };

  cancelPayable = async (id: string) => {
    const res = await api().post(`/finance/payables/${id}/cancel`);
    return res.data as FinanceEntryType;
  };

  payablesSummary = async () => {
    const res = await api().get("/finance/payables/summary");
    return res.data as FinanceSummaryType;
  };

  listReceivables = async (params?: Record<string, unknown>) => {
    const res = await api().get("/finance/receivables", { params });
    return res.data as { data: FinanceEntryType[]; total: number };
  };

  getReceivable = async (id: string) => {
    const res = await api().get(`/finance/receivables/${id}`);
    return res.data as FinanceEntryType;
  };

  createReceivable = async (data: Record<string, unknown>) => {
    const res = await api().post("/finance/receivables", data);
    return res.data as FinanceEntryType;
  };

  updateReceivable = async (id: string, data: Record<string, unknown>) => {
    const res = await api().put(`/finance/receivables/${id}`, data);
    return res.data as FinanceEntryType;
  };

  markReceivablePaid = async (id: string, paidAt?: string) => {
    const res = await api().post(`/finance/receivables/${id}/pay`, { paidAt });
    return res.data as FinanceEntryType;
  };

  cancelReceivable = async (id: string) => {
    const res = await api().post(`/finance/receivables/${id}/cancel`);
    return res.data as FinanceEntryType;
  };

  receivablesSummary = async () => {
    const res = await api().get("/finance/receivables/summary");
    return res.data as FinanceSummaryType;
  };
}

export const financeApi = new FinanceApi();
